/**
 * Preferencia de tema (claro u oscuro) de la persona, guardada en el navegador.
 *
 * Por defecto es claro: el modo oscuro es opt-in desde el menú de la cuenta.
 * El storage puede fallar (ventana privada, datos bloqueados): en ese caso la
 * preferencia dura lo que la sesión y nunca revienta la carga.
 */
const KEY = 'gsf.theme';

export function loadThemeDark() {
    try {
        return window.localStorage.getItem(KEY) === 'dark';
    } catch (e) {
        return false;
    }
}

export function saveThemeDark(dark) {
    try {
        window.localStorage.setItem(KEY, dark ? 'dark' : 'light');
    } catch (e) {
        // sin storage: la preferencia dura lo que la sesión
    }
}
